import css from './PickerSearch.scss';

/** Class for the antd Input that searches an Inspector picker: tokens, assets and design presets */
export const pickerSearchClassName = css.search;
